import BottomStrip from './BottomStrip';

export default BottomStrip;